<script setup>

import {router} from "@inertiajs/vue3";
import Button from "primevue/button";
import {ref} from "vue";

const props = defineProps({
    theme: Object,
    roundness: String,
    forms: Object,
    resultForm: Object,
    loading: Boolean,
})
</script>

<template>
        <Button
            :class="[`!bg-${theme.color}-500 !px-6 !py-3 !border-none hover:!bg-${theme.color}-600`, roundness]"
            :loading="loading" :label="$t('widget.book')"></Button>
</template>

<style scoped lang="scss">

</style>
